import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/regenerator";
import { getTemplate } from "codesandbox-import-utils/lib/create-sandbox/templates";
import isEqual from "lodash.isequal"; // Muhahaha
// eslint-disable-next-line
// @ts-ignore

import { version } from "../package.json";
import Protocol from "./file-resolver-protocol";
import { IFrameProtocol } from "./iframe-protocol";
import { createPackageJSON, addPackageJSONIfNeeded, extractErrorDetails } from "./utils";
var BUNDLER_URL = process.env.CODESANDBOX_ENV === "development" ? "http://localhost:3000/" : "https://".concat(version.replace(/\./g, "-"), "-sandpack.codesandbox.io/");
export var SandpackClient = /*#__PURE__*/function () {
  function SandpackClient(selector, sandboxInfo) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, SandpackClient);

    this.getTranspilerContext = function () {
      return new Promise(function (resolve) {
        var unsubscribe = _this.listen(function (message) {
          if (message.type === "transpiler-context") {
            resolve(message.data);
            unsubscribe();
          }
        });

        _this.dispatch({
          type: "get-transpiler-context"
        });
      });
    };

    this.options = options;
    this.sandboxInfo = sandboxInfo;
    this.bundlerURL = options.bundlerURL || BUNDLER_URL;
    this.bundlerState = undefined;
    this.errors = [];
    this.status = "initializing";

    if (typeof selector === "string") {
      this.selector = selector;
      var element = document.querySelector(selector);

      if (!element) {
        throw new Error("No element found for selector '".concat(selector, "'"));
      }

      this.element = element;
      this.iframe = document.createElement("iframe");
      this.initializeElement();
    } else {
      this.element = selector;
      this.iframe = selector;
    }

    if (!this.iframe.getAttribute("sandbox")) {
      this.iframe.setAttribute("sandbox", "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts");
    }

    this.iframe.src = options.startRoute ? new URL(options.startRoute, this.bundlerURL).toString() : this.bundlerURL;
    this.iframeProtocol = new IFrameProtocol(this.iframe, this.bundlerURL);
    this.unsubscribeGlobalListener = this.iframeProtocol.globalListen(function (mes) {
      if (mes.type !== "initialized" || !_this.iframe.contentWindow) {
        return;
      }

      _this.iframeProtocol.register();

      if (_this.options.fileResolver) {
        // TODO: Find a common place for the Protocol to be implemented for both sandpack-core and sandpack-client
        _this.fileResolverProtocol = new Protocol("file-resolver", /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(data.m === "isFile")) {
                      _context.next = 2;
                      break;
                    }

                    return _context.abrupt("return", _this.options.fileResolver.isFile(data.p));

                  case 2:
                    return _context.abrupt("return", _this.options.fileResolver.readFile(data.p));

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }(), _this.iframe.contentWindow);
      }

      _this.updatePreview(_this.sandboxInfo, true);
    });
    this.unsubscribeChannelListener = this.iframeProtocol.channelListen(function (mes) {
      switch (mes.type) {
        case "start":
          {
            _this.errors = [];
            break;
          }

        case "status":
          {
            _this.status = mes.status;
            break;
          }

        case "action":
          {
            if (mes.action === "show-error") {
              _this.errors = [].concat(_toConsumableArray(_this.errors), [extractErrorDetails(mes)]);
            }

            break;
          }

        case "state":
          {
            _this.bundlerState = mes.state;
            break;
          }
      }
    });
  }

  _createClass(SandpackClient, [{
    key: "cleanup",
    value: function cleanup() {
      this.unsubscribeChannelListener();
      this.unsubscribeGlobalListener();
      this.iframeProtocol.cleanup();
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      if (!isEqual(this.options, options)) {
        this.options = options;
        this.updatePreview();
      }
    }
  }, {
    key: "updatePreview",
    value: function updatePreview() {
      var sandboxInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.sandboxInfo;
      var isInitializationCompile = arguments.length > 1 ? arguments[1] : undefined;

      var _a, _b, _c;

      this.sandboxInfo = sandboxInfo;
      var files = this.getFiles();
      var modules = Object.keys(files).reduce(function (prev, next) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, next, {
          code: files[next].code,
          path: next
        }));
      }, {});
      var packageJSON = JSON.parse(createPackageJSON(this.sandboxInfo.dependencies, this.sandboxInfo.entry));

      try {
        packageJSON = JSON.parse(files["/package.json"].code);
      } catch (e) {
        console.error("Could not parse package.json file: " + e.message);
      } // TODO move this to a common format


      var normalizedModules = Object.keys(files).reduce(function (prev, next) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, next, {
          content: files[next].code,
          path: next
        }));
      }, {});
      this.dispatch({
        type: "compile",
        codesandbox: true,
        version: 3,
        isInitializationCompile: isInitializationCompile,
        modules: modules,
        externalResources: [],
        hasFileResolver: Boolean(this.options.fileResolver),
        disableDependencyPreprocessing: this.sandboxInfo.disableDependencyPreprocessing,
        template: this.sandboxInfo.template || getTemplate(packageJSON, normalizedModules),
        showOpenInCodeSandbox: (_a = this.options.showOpenInCodeSandbox) !== null && _a !== void 0 ? _a : true,
        showErrorScreen: (_b = this.options.showErrorScreen) !== null && _b !== void 0 ? _b : true,
        showLoadingScreen: (_c = this.options.showLoadingScreen) !== null && _c !== void 0 ? _c : true,
        skipEval: this.options.skipEval || false,
        clearConsoleDisabled: !this.options.clearConsoleOnFirstCompile
      });
    }
  }, {
    key: "dispatch",
    value: function dispatch(message) {
      this.iframeProtocol.dispatch(message);
    }
  }, {
    key: "listen",
    value: function listen(listener) {
      return this.iframeProtocol.channelListen(listener);
    }
    /**
     * Get the URL of the contents of the current sandbox
     */

  }, {
    key: "getCodeSandboxURL",
    value: function getCodeSandboxURL() {
      var files = this.getFiles();
      var paramFiles = Object.keys(files).reduce(function (prev, next) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, next.replace("/", ""), {
          content: files[next].code,
          isBinary: false
        }));
      }, {});
      return fetch("https://codesandbox.io/api/v1/sandboxes/define?json=1", {
        method: "POST",
        body: JSON.stringify({
          files: paramFiles
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }).then(function (x) {
        return x.json();
      }).then(function (res) {
        return {
          sandboxId: res.sandbox_id,
          editorUrl: "https://codesandbox.io/s/".concat(res.sandbox_id),
          embedUrl: "https://codesandbox.io/embed/".concat(res.sandbox_id)
        };
      });
    }
  }, {
    key: "getFiles",
    value: function getFiles() {
      var sandboxInfo = this.sandboxInfo;

      if (sandboxInfo.files["/package.json"] === undefined) {
        return addPackageJSONIfNeeded(sandboxInfo.files, sandboxInfo.dependencies, sandboxInfo.entry);
      }

      return this.sandboxInfo.files;
    }
  }, {
    key: "initializeElement",
    value: function initializeElement() {
      this.iframe.style.border = "0";
      this.iframe.style.width = this.options.width || "100%";
      this.iframe.style.height = this.options.height || "100%";
      this.iframe.style.overflow = "hidden";

      if (!this.element.parentNode) {
        // This should never happen
        throw new Error("Given element does not have a parent.");
      }

      this.element.parentNode.replaceChild(this.iframe, this.element);
    }
  }]);

  return SandpackClient;
}();